import { IUpdateSettingsRequest } from "shared";

import { useAllowedFeature } from "../../../../hooks/useAllowedFeature";
import { classNames } from "../../../../../common/lib/classNames";
import { TwoColFormRow } from "../../../Molecules/Form/TwoColFormRow";
import { UpgradeBadge } from "../../../Molecules/UpgradeBadge";
import { OnChangeFn } from "../Main/GeneralSettings";
import { Toggle } from "../../../../../common/Atoms/Toggle";

interface PaymentPlanGlobalSettingsProps {
  formData: IUpdateSettingsRequest;
  onChange: OnChangeFn;
}

export function PaymentPlanGlobalSettings({ formData, onChange }: PaymentPlanGlobalSettingsProps) {
  const allowedFeature = useAllowedFeature(`paymentPlans`);

  function handleChange(e) {
    onChange(e.name, e.value);
  }

  const badge = !allowedFeature && (
    <UpgradeBadge />
  );

  return (
    <TwoColFormRow
      heading={ `Payment Plan General Settings` }
      badge={ badge }
      help={
        allowedFeature ?
          undefined :
          `Upgrade to "Pro" to enable payment plans.`
      }
    >
      <div className={
        classNames(
          `space-y-2`,
          allowedFeature ? `` : `opacity-50`,
        )
      }>
        <Toggle
          name={ `paymentPlanNotesEnabled` }
          checked={ formData.paymentPlanNotesEnabled || false }
          label={ `Create notes when payment plans are created or removed` }
          onChange={ handleChange }
          disabled={ !allowedFeature }
          description={ `Create an invoice note each time a payment plan is created or removed.` }
        />

      </div>
    </TwoColFormRow>
  );
}
